import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { map } from 'lodash';
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  PopoverBody,
} from 'reactstrap';
import { UncontrolledPopover } from 'reactstrap/lib';
import Moment from 'react-moment';
import 'react-widgets/dist/css/react-widgets.css';
import * as constants from '../../../constants/constants';
import {
  getSuspiciousLeftFirstRoundData,
  getOneGames,
  getRoomLog,
  getRoomOptions,
  getBotUsers,
  removeRankGrasshopper,
  addRankGrasshopper,
  checkRankPlayers,
} from '../../../actions/admin';
import PaginationOld from '../Menu/PaginationOld';
import RoomLogs from './RoomLogs';

let carretDown = '\u{25bc}';
let carretUp = '\u{25b2}';

const OneGames = ({ offset }) => {
  const { t } = useTranslation('admin');
  const dispatch = useDispatch();

  const suspiciousLeftFirstRound = useSelector(state => state.admin.suspiciousLeftFirstRound || []);
  const suspiciousLeftFirstRoundData = useSelector(state => state.admin.suspiciousLeftFirstRoundData || {});

  const selectedRoomData = useSelector(state => state.admin.roomData || {});
  const selectedroomOptions = useSelector(state => state.admin.roomOptions || {});

  const bots = useSelector(state => state.admin.bots || {});

  const [openModal, setOpenModal] = useState(false);
  const [roomViewModal, setRoomViewModal] = useState(false);
  const [selectedRoomId, setSelectedRoomId] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const pageSize = 50;
  const [sortOrder, setSortOrder] = useState('desc');

  useEffect(() => {
    dispatch(getOneGames());
    dispatch(checkRankPlayers());
    dispatch(getBotUsers());
  }, []);

  useEffect(() => {
    if (selectedRoomId) {
      dispatch(getRoomLog(selectedRoomId));
      dispatch(getRoomOptions(selectedRoomId));
    }
  }, [selectedRoomId]);

  const handlePagination = (e, index) => {
    e.preventDefault();
    setCurrentPage(index);
  };

  const openModalFunc = (item) => {
    setOpenModal(true);
    dispatch(getSuspiciousLeftFirstRoundData(item.uid));
  };

  const closeModalFunc = () => {
    setOpenModal(false);
  };

  const openRoomModal = (item) => {
    setRoomViewModal(true);
    setSelectedRoomId(item.roomId);
  };

  const toggleRoom = () => {
    setRoomViewModal(false);
    setSelectedRoomId('');
  };

  const toggleRank = (item) => {
    if (item.rankG) {
      dispatch(removeRankGrasshopper(item));
    } else {
      dispatch(addRankGrasshopper(item));
    }
  };

  const getPercentage = (count, totalCount) => {
    if (totalCount && totalCount > 0) {
      return ((count / totalCount) * 100).toFixed(1);
    }
    return 'N/A';
  };

  const toggleSortOrder = () => {
    if (sortOrder === 'desc') {
      setSortOrder('asc');
    } else {
      setSortOrder('desc');
    }
  };

  // if (selectId && globalRoomData[selectId]) {
  //   openRoomModal(globalRoomData[selectId]);
  //   setSelectId(null);
  // }
  const pagesCount = Math.ceil(suspiciousLeftFirstRound.length / pageSize);

  return (
    <Fragment>
      <UncontrolledPopover popperClassName="popover" placement="right" trigger="focus" target="admin-help-button-one-games">
        <PopoverBody className="popover-body">
          A list of players who leaves the room after the first game.
        </PopoverBody>
      </UncontrolledPopover>
      <div className="admin-page-content">
        <Row>
          <Col sm="4">
            <h2>
              One Games
              <Button className="admin-help-button" id="admin-help-button-one-games">
                ?
              </Button>
            </h2>
          </Col>
        </Row>

        <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
          <colgroup>
            <col span="1" className="" />
          </colgroup>
          <thead>
            <tr>
              <th style={{ textAlign: 'center' }}>
                Name
              </th>
              <th style={{ textAlign: 'center' }}>
                Player Id
              </th>
              <th style={{ textAlign: 'center' }}>
                Count
              </th>
              <th className="cursor-pointer" style={{ textAlign: 'center' }} onClick={() => toggleSortOrder()}>
                Percentage
                {sortOrder === 'desc' ? (carretUp) : (carretDown)}
              </th>
              <th style={{ textAlign: 'center' }}>
                View
              </th>
              <th style={{ textAlign: 'center' }}>
                Rank(Grasshopper)
              </th>
            </tr>
          </thead>
          <tbody>
            {suspiciousLeftFirstRound && Object.keys(suspiciousLeftFirstRound)
              .sort((a, b) => {
                if (sortOrder === 'desc') {
                  return (getPercentage(suspiciousLeftFirstRound[b].count, suspiciousLeftFirstRound[b].totalCount) - getPercentage(suspiciousLeftFirstRound[a].count, suspiciousLeftFirstRound[a].totalCount));
                } else {
                  return (getPercentage(suspiciousLeftFirstRound[a].count, suspiciousLeftFirstRound[a].totalCount) - getPercentage(suspiciousLeftFirstRound[b].count, suspiciousLeftFirstRound[b].totalCount));
                }
              })
              .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
              .map((key, idx) => (
              <Fragment key={key}>
                <tr key={key} className="allUsers-table-row">
                  <td className="allUsers-table-col">
                    {suspiciousLeftFirstRound[key].name}
                  </td>
                  <th style={{ textAlign: 'center' }}>
                    {suspiciousLeftFirstRound[key].uid}
                  </th>
                  <td className="allUsers-table-col">
                    {suspiciousLeftFirstRound[key].count}
                  </td>
                  <td className="allUsers-table-col">
                    {getPercentage(suspiciousLeftFirstRound[key].count, suspiciousLeftFirstRound[key].totalCount)}%
                  </td>
                  <td className="allUsers-table-col">
                    <Button onClick={() => openModalFunc(suspiciousLeftFirstRound[key])}>
                      View
                    </Button>
                  </td>
                  <td className="allUsers-table-col">
                    <Button color={suspiciousLeftFirstRound[key].rankG ? 'warning' : 'primary'} onClick={() => toggleRank(suspiciousLeftFirstRound[key])}>
                      {suspiciousLeftFirstRound[key].rankG ? 'Remove' : 'Add'}
                    </Button>
                  </td>
                </tr>
              </Fragment>
              ))}
          </tbody>
        </table>

        <PaginationOld
          show
          currentPage={currentPage}
          pagesCount={pagesCount}
          handlePagination={handlePagination}
        />
      </div>

      <Modal container={'div > div'} isOpen={openModal} toggle={closeModalFunc} size="lg">
        <ModalHeader toggle={closeModalFunc}>
          Data
        </ModalHeader>
        <ModalBody className="modal-scroll-body">
          <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
            <colgroup>
              <col span="1" className="" />
            </colgroup>
            <thead>
              <tr>
                <th style={{ textAlign: 'center' }}>
                  Date
                </th>
                <th style={{ textAlign: 'center' }}>
                  Room Id
                </th>
                <th style={{ textAlign: 'center' }}>
                  Bet
                </th>
                <th style={{ textAlign: 'center' }}>
                  Min Rounds
                </th>
                <th style={{ textAlign: 'center' }}>
                  Room Completed
                </th>
                <th style={{ textAlign: 'center' }}>
                  View
                </th>
              </tr>
            </thead>
            <tbody>
              {
                Object.keys(suspiciousLeftFirstRoundData).length > 0 &&Object.keys(suspiciousLeftFirstRoundData).sort((a, b) => suspiciousLeftFirstRoundData[b].date - suspiciousLeftFirstRoundData[a].date).map(key => (
                  <Fragment key={key}>
                    <tr className="allUsers-table-row">
                      <td className="allUsers-table-col">
                        <Moment format={constants.FORMAT_DATE_TYPE.fullDateSecond} locale={constants.sendLanguage.lv}>
                          {suspiciousLeftFirstRoundData[key].date + offset}
                        </Moment>
                      </td>
                      <td className="allUsers-table-col">
                        {suspiciousLeftFirstRoundData[key].roomId}
                      </td>
                      <td className="allUsers-table-col">
                        {suspiciousLeftFirstRoundData[key].bet}
                      </td>
                      <td className="allUsers-table-col">
                        {suspiciousLeftFirstRoundData[key].minGames}
                      </td>
                      <td className="allUsers-table-col">
                        {suspiciousLeftFirstRoundData[key].rPlayed >= suspiciousLeftFirstRoundData[key].minGames ? 'Yes' : 'No'}
                      </td>
                      <td className="allUsers-table-col">
                        <Button onClick={() => openRoomModal(suspiciousLeftFirstRoundData[key])}>
                          View
                        </Button>
                      </td>
                    </tr>
                  </Fragment>
                ))
              }
            </tbody>
          </table>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeModalFunc}>Close</Button>
        </ModalFooter>
      </Modal>

      <Modal container={'div > div'} isOpen={roomViewModal} toggle={toggleRoom} style={{ maxWidth: '65%' }}>
        <ModalHeader toggle={toggleRoom}>
          {/* {selectedroomOptions ? `Room: ${selectedRoomId}, Bet: ${selectedroomOptions.bet}, ${selectedroomOptions.minGames ? `Min Rounds: ${selectedroomOptions.minGames}` : ''}, ${selectedroomOptions.fourPRoom ? '4' : '3'} Players` : ''} */}
          {selectedroomOptions ? `Room: ${selectedRoomId}, Game type: ${selectedroomOptions.smallGame ? `${selectedroomOptions.gameType ? selectedroomOptions.gameType : 'P'}M` : `${selectedroomOptions.gameType ? selectedroomOptions.gameType : 'P'}`}, Bet: ${selectedroomOptions.bet}, Speed: ${constants.SPEED_TYPE[selectedroomOptions.speed]}, ${selectedroomOptions.minGames ? `Min Games: ${selectedroomOptions.minGames}` : ''}, ${selectedroomOptions.studentRoom ? '2' : (selectedroomOptions.fourPRoom ? '4' : '3')} Players` : ''}
        </ModalHeader>
        <ModalBody>
          <RoomLogs roomData={selectedRoomData} roomId={selectedRoomId} roomParams={selectedroomOptions} bots={bots} offset={offset} />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleRoom}>Close</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

OneGames.propTypes = {
  member: PropTypes.shape({
    email: PropTypes.string,
  }),
  allSuspiciousRoomLeftPlayers: PropTypes.shape({}),
};

OneGames.defaultProps = {
  member: {},
  allSuspiciousRoomLeftPlayers: [],
};

export default OneGames;
